import request from '@/axios'

export function manualInvoiceList (customer_id, page, payload) {
  return request({
    url:`/manual_invoices/list/${customer_id}?page=${page.page}&limit=${page.limit}`,
    method:'POST',
    data: payload
  })
}

export function updatePaymentStatus (payload) { //
  return request({
    url: '/manual_invoices/update-payment-status',
    method: 'POST',
    data:payload
  })
}

export function showManualInvoice (customer_id, invoice_id) {
  return request({
    url: `/manual_invoices/show/${customer_id}/${invoice_id}`,
    method: 'GET'
  })
}

export function getSchoolDetails (payload) { //
  return request({
    url: '/manual_invoices/get-school-details',
    method: 'POST',
    data:payload
  })
}

export function deleteManualInvoice (customer_id, payload) {
  return request({
    url: `/manual_invoices/delete/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function shareManualInvoice (payload) {
  return request({
    url: '/manual_invoices/share-to-client',
    method: 'POST',
    data:payload
  })
}


export function createManualInvoice (payload) { //
  return request({
    url: '/manual_invoices/create',
    method: 'POST',
    data:payload
    
  })
}

export function getPdfDownload (payload) {
  return request({
    url: '/manual_invoices/download/pdf',
    method: 'POST',
    data:payload
    
  })
}

export function qbItemList (payload) {
  return request({
    url: '/manual_invoices/list-qb-items',
    method: 'POST',
    data:payload
    
  })
}

export function createQbItem (payload) {
  return request({
    url: '/manual_invoices/create-qb-item',
    method: 'POST',
    data:payload
    
  })
}

export function createQbTax (payload) {
  return request({
    url: '/manual_invoices/create-qb-tax',
    method: 'POST',
    data:payload
    
  })
}
export function QbListTax (payload) {
  return request({
    url: '/manual_invoices/list-qb-taxes',
    method: 'POST',
    data:payload
    
  })
}

export function fetchManualFinanceBySearch (payload, page, query) {
  return request({
    url: `manual_invoices/global_search?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page.page}&limit=${page.limit}`,
    method: 'POST',
    data:payload
    
  })
}